import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    contentItem: {
        width: '100%',
        height: 70,
        borderRadius: 10,
        padding: 10,
        flexDirection: 'row',
        marginBottom: 10,
        borderWidth: 1,
        borderColor: '#24909c',
        marginTop: 10
    },
    img: {
        width: 30,
        height: 30,
        marginTop: 10,
        marginLeft: 10,
    },
    textsItem: {
        marginLeft: 20
    },
    infoPrice: {
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    titleCoin: {
        fontSize: 12,
        fontWeight: 'bold',
        marginTop: 5
    },
    infosCoin: {
        fontSize: 10,
        color: '#2C2C2E',
        fontWeight: '400'
    },
    priceCoin: {
        fontSize: 10,
        color: '#2C2C2E',
        fontWeight: '600'
    },
    currencyPercentage: {
        color: 'green',
        fontSize: 10,
        position: 'absolute',
        right: 65,
        marginTop: 28
    },
    iconGo: {
        position: 'absolute',
        right: 10,
        marginTop: 10
    },
    tokens_list: {
        width: "100%",
        height: "100%",
        alignItems: "center",
        backgroundColor: "#fff",
        borderTopLeftRadius: 35,
        borderTopRightRadius: 35,
    },
    tokens_display_action: {
        alignItems: "center",
        paddingVertical: 10,
    },
    token: {
        flex: 1,
        padding: 10,
        borderWidth: 1,
        borderRadius: 5,
        marginBottom: 20,
        alignItems: "center",
        flexDirection: "row",
        borderColor: "#F4F4F4",
        justifyContent: "space-between",
    },
    scroll_view: {
        flex: 1,
        width: "100%",
        padding: 20,
        position: "absolute",
        top: "25%",
        height: "50%",
    },

    token_header_container: {
        paddingHorizontal: "10%",
        marginTop: 25,
        flexDirection: "row",
        alignItems: "center",
    },
    token_header: {
        borderWidth: 3,
        width: 75,
        height: 75,
        borderColor: "#32BFB1",
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        marginRight: 15,
    },
    token_header_image: {
        width: 65,
        height: 65,
    },
    token_header_title: {
        fontSize: 16,
        fontWeight: "bold",
        color: "#2C2C2E",
    },
    token_header_info: {
        fontSize: 12,
        color: "#2C2C2E",
        opacity: 0.5,
    },
    token_header_value: {
        fontWeight: "bold",
        color: "#32BFB1",
        fontSize: 20,
    },
    token_info_container: {
        marginTop: 20,
        paddingHorizontal: "10%",
        flexDirection: "row",
        justifyContent: "space-around",
    },
    token_info: {
        alignItems: "center",
    },
    token_info_title: {
        fontSize: 10,
        textTransform: "uppercase",
    },
    token_percent_value: {
        fontSize: 10,
        color: "#32BFB1",
    },
    token_default_info_value: {
        fontSize: 10,
        color: "#2C2C2E",
        opacity: 0.7,
    },
    hl: {
        height: 2,
        width: "90%",
        marginTop: 10,
        marginLeft: "5%",
        backgroundColor: "#2C2C2E",
        opacity: 0.5,
        paddingHorizontal: "10%",
    },
    hr: {
        height: 2,
        // width: "90%",
        marginTop: 10,
        // marginLeft: "5%",
        backgroundColor: "#2C2C2E",
        opacity: 0.5,
        // paddingHorizontal: "10%",
    },
    balance_info_container: {
        // flex: 1,
        flexDirection: "row",
        paddingHorizontal: "10%",
        marginTop: 5,
        alignSelf: 'center',
        justifyContent: "space-between",
        marginBottom: 10
    },
    balance_info_title: {
        fontSize: 14,
        fontWeight: "bold",
        textAlign: 'center'
    },
    balance_info_value: {
        fontSize: 14,
        color: "#2C2C2E",
        opacity: 0.7,
        textAlign: 'center'
    },
    action_buttons_container: {
        // position: "relative",
        // bottom: 35,
        // left: "5%",
        marginTop: 20,
        paddingHorizontal: "10%",
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "center",
        marginBottom: 20
    },
    action_button: {
        padding: 10,
        marginHorizontal: 15,
        borderRadius: 20,
        width: 150
    },
    action_button_text: {
        textTransform: "uppercase",
        fontWeight: "bold",
        color: "#FFF",
        textAlign: 'center'
    },
    contentPageTab: {
        paddingHorizontal: 25
    },
    contentPurchase: {
        paddingHorizontal: 25,
        marginTop: 10
    },
    titlePurchase: {
        textAlign: 'center',
        marginBottom: 20
    },
    contentPurchaseAmount: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 10
    },
    contentOrders: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    orderPurchases: {
        fontSize: 12
    },
    orderPurchasesBold: {
        fontSize: 12,
        fontWeight: 'bold'
    },
    orderSale: {
        fontSize: 12
    },
    orderSaleBold: {
        fontSize: 12,
        fontWeight: 'bold'
    },
    contentDescriptionOrders: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: 5
    },
    textDescriptionsOrders: {
        fontSize: 12
    },
    contentPurchaseOrSale: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    amountPurchase: {
        fontSize: 12
    },
    pricePurchase: {
        fontSize: 12,
        color: 'green'
    },
    amountSale: {
        fontSize: 12
    },
    priceSale: {
        fontSize: 12,
        color: '#B90000'
    },
    contentInfoGraphic: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    titleInfoGraphic: {
        fontSize: 12,
        fontWeight: 'bold',
        marginTop: 10
    },
    infoGraphic: {
        color: 'rgba(44, 44, 46, 0.5)',
        fontSize: 10,
        marginTop: 10
    },
    dropdown: {
        // width: '85%',
        height: 30,
        // marginTop: 15,

    },
    numberInput: {
        flex: 1,
        backgroundColor: "#f1f1f1",
        borderWidth: 1,
        borderColor: "#ccc"
    },
    modalCenteredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    closeModal: {
        marginLeft: "auto",
        marginRight: -20,
    },
    modalView: {
        width: "auto",
        marginTop: 20,
        backgroundColor: '#ffffff',
        borderRadius: 20,
        paddingHorizontal: 35,
        paddingVertical: 15,
        alignItems: "center",
        overflow: 'hidden',
        shadowOpacity: 0.2,
        shadowColor: '#000',
        shadowRadius: 0,
        shadowOffset: {
            width: 0,
            height: 0
        }
    },
});

export default styles;

